import { render, staticRenderFns } from "./GameScrollableStickyHeader.vue?vue&type=template&id=64768b0a&scoped=true&"
import script from "./GameScrollableStickyHeader.vue?vue&type=script&lang=js&"
export * from "./GameScrollableStickyHeader.vue?vue&type=script&lang=js&"
import style0 from "./GameScrollableStickyHeader.vue?vue&type=style&index=0&id=64768b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64768b0a",
  null
  
)

export default component.exports